import React from 'react'

import "../../styles/css/about.css"
const AboutHeader = () => {
    return (
        <div className="about__header"><h1><span>About </span>Me</h1></div>)
}

export default AboutHeader